import { Component } from "@angular/core";

@Component({
    selector: 'admin-layout',
    templateUrl: './admin.layout.html',
    styleUrls: ['./admin.layout.scss'],
    standalone: false
})
export class AdminLayout {
    //
}